import React, { useRef, useContext, useEffect } from 'react';
import WizardStateContext from '../context/wizardstate';
import { AREA_RESPONSES } from 'components/Wizards/RTDV/types';
import { REPORT_TYPES } from 'components/Wizards/Dashlet/types';

const disallowedReportTypes = [AREA_RESPONSES.PIVOT_TABLE];
const disallowedReportTypesOnUpdate = [
  REPORT_TYPES.SCHEDULED_ACTIVITIES,
  AREA_RESPONSES.TABLE,
]; // scroll once and other updates are opted out of scrolling

const BottomScrollPosition = ({
  canAutoScroll = false,
  modalBody = null,
  setCanAutoScroll,
}) => {
  const bottomScrollerRef = useRef(null);
  const hasScrolled = useRef(false);
  const { currentStep, state, isGenerating } = useContext(
    WizardStateContext.Context
  );

  const reportType = state.reportType?.value;
  const disallow = disallowedReportTypes.includes(reportType);
  const disallowOnUpdate =
    hasScrolled.current && disallowedReportTypesOnUpdate.includes(reportType);

  useEffect(() => {
    hasScrolled.current = false;
  }, [reportType]);

  useEffect(() => {
    if (canAutoScroll && !disallow && !disallowOnUpdate && !isGenerating) {
      bottomScrollerRef?.current?.scrollIntoView?.({ behavior: 'smooth' });
      hasScrolled.current = true;
    }
  }, [
    currentStep,
    canAutoScroll,
    disallow,
    disallowOnUpdate,
    state,
    isGenerating,
  ]);

  useEffect(() => {
    if (modalBody.current?.scrollHeight === modalBody.current?.clientHeight) {
      setCanAutoScroll(true);
    }
  }, [currentStep, state, modalBody, setCanAutoScroll]);

  return <div ref={bottomScrollerRef} />;
};

export default BottomScrollPosition;
